//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  computed: {
    cssClasses: function cssClasses() {
      var classes = this.$classes().concat("layouts-horizontal");
      var distribution = this.spec.distribution;

      switch (distribution) {
        case "fillEqually":
          classes.push("layouts-horizontal--fill-equally");
          break;

        case "spaceEqually":
          classes.push("layouts-horizontal--space-equally");
          break;

        default:
          Utils.type.ifString(distribution, function (distribution) {
            // Uses Material Design spacings: https://vuetifyjs.com/en/styles/spacing/#how-it-works
            if (distribution.startsWith("overlap")) {
              classes.push("layouts-horizontal--".concat(distribution));
            }
          });
          break;
      }

      return classes;
    },
    cssStyles: function cssStyles() {
      var styles = this.genericStyles();

      switch (this.spec.align) {
        case "middle":
          styles["align-items"] = "center";
          break;

        case "bottom":
          styles["align-items"] = "flex-end";
          break;

        default:
          styles["align-items"] = "flex-start";
      }

      return styles;
    },
    componentName: function componentName() {
      return this.$href() ? "a" : "div";
    }
  },
  methods: {
    $displayValue: function $displayValue() {
      return "flex";
    }
  }
};